import { useEffect, useState, useRef } from "react";
import { useParams, Link, useHistory } from "react-router-dom/cjs/react-router-dom.min"
import Loader from "../shared/loader";
import stringHelpers from "../../utilities/stringHelpers";
import Api from "../api/api";
import Enums from "../../utilities/enum";
import { sortArrayOfObjectsByTimestampProperty, toDateTimeString, toDateString, toLongDateTimeString } from "../../utilities/dateUtilities";
import arrayUtilities from "../../utilities/arrayUtilities";
import { Modal } from "react-bootstrap";
import { ErrorModal } from "../../utilities/errorModal";
import { AttachmentsDisplay } from '../shared/attachmentsDisplay';
import AttachmentSelectTable from '../shared/attachmentSelectTable';
import { NewLetterEditTemplateItem } from "./newLetterEditTemplateItem";
import roleUtilities from "../../utilities/roleUtilities";

export const AppealResponse = ({ organisationId, token, user }) => {
    const { breachId, appealId, responseType } = useParams()
    const history = useHistory();

    const breachDetailsUrl = `/organisation/${ organisationId }/breach/${ breachId }`
    const appealDetailsUrl = `${breachDetailsUrl}/appeal/${ appealId }`
    
    const [isLoadingPage, setIsLoadingPage] = useState(false)
    const [isLoadingPreview, setIsLoadingPreview] = useState(false);
    const [isSendingResponse, setIsSendingResponse] = useState(false);
    const [emailPreview, setEmailPreview] = useState(null);
    const [breach, setBreach] = useState(null);
    const [appeal, setAppeal] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");
    const [attachments, setAttachments] = useState(null);
    const [attachmentsDefaultTab, setAttachmentsDefaultTab] = useState("images");
    const attachmentsLayoutKey = `${ user.id }-appealAttachmentLayoutPreference`;
    const [attachmentsLayout, setAttachmentsLayout] = useState(localStorage.getItem(attachmentsLayoutKey) ?? 'grid');
    const [dropUploads, setDropUploads] = useState([]);
    const [isDraggingOver, setIsDraggingOver] = useState(false);
    const fileInputRef = useRef(null);
    const [breachAttachments, setBreachAttachments] = useState(null);
    const [selectedBreachAttachments, setSelectedBreachAttachments] = useState([]);
    const [isSelectAllBreachAttachmentsChecked, setIsSelectAllBreachAttachmentsChecked] = useState(false);
    const [siteAttachments, setSiteAttachments] = useState(null);
    const [selectedSiteAttachments, setSelectedSiteAttachments] = useState([]);
    const [isSelectAllSiteAttachmentsChecked, setIsSelectAllSiteAttachmentsChecked] = useState(false);
    const [attachmentModalId, setAttachmentModalId] = useState(null)
    const [responseMode, setResponseMode] = useState("0")
    const [appealOptions, setAppealOptions] = useState(null)
    const [emailTemplate, setEmailTemplate] = useState(null)
    const [emailPreviewError, setEmailPreviewError] = useState(null)
    const [templateItems, setTemplateItems] = useState(null);
    const [letterTemplate, setLetterTemplate] = useState(null);
    const [appealSupplementaryResponses, setAppealSupplementaryResponses] = useState(null);
    const [selectedAppealSupplementaryResponse, setSelectedAppealSupplementaryResponse] = useState(null);
    const [pdfView, setPdfView] = useState(null);
    const [isPreviewCovered, setIsPreviewCovered] = useState(false);

    const getBreach = function () {
        setIsLoadingPage(true)
        Api.getBreach(
            (data) => {
                setBreach(data)
                getResponseAttachments(data)
                setIsLoadingPage(false)
            },
            (error) => {
                console.log(error)
                setIsLoadingPage(false)
            },
            breachId,
            organisationId,
            token
        )
    };

    const collateResponseAttachmentIds = () => {
        let ids = [];
        if (!arrayUtilities.isNullOrEmpty(selectedBreachAttachments)) {
            ids = selectedBreachAttachments;
        }
        if (!arrayUtilities.isNullOrEmpty(selectedSiteAttachments)) {
            ids = [...ids, ...selectedSiteAttachments];
        }
        return ids;
    };

    const getAppeal = function () {
        setIsLoadingPage(true)
        Api.getAppeal(
            (data) => {
                setAppeal(data)
                setIsLoadingPage(false)
            },
            (error) => {
                console.log(error)
                setIsLoadingPage(false)
            },
            breachId, appealId,
            organisationId,
            token
        )
    };

    const changeSubjectTimeout = useRef();
    const changeSubject = (newSubject) => {
        setEmailTemplate(prevState => ({
            ...prevState,
            subject: newSubject
        }))
        setIsPreviewCovered(true)

        if (changeSubjectTimeout.current) {
            clearTimeout(changeSubjectTimeout.current);
            changeSubjectTimeout.current = null;
        }

        changeSubjectTimeout.current = setTimeout(() => {
            refreshEmailPreview(newSubject, emailTemplate.content, emailTemplate.status)
        }, 1000)

    }

    const changeContentTimeout = useRef();
    const changeContent = (newContent) => {
        setEmailTemplate(prevState => ({
            ...prevState,
            content: newContent
        }))
        setIsPreviewCovered(true)

        if (changeContentTimeout.current) {
            clearTimeout(changeContentTimeout.current);
            changeContentTimeout.current = null;
        }

        changeContentTimeout.current = setTimeout(() => {
            refreshEmailPreview(emailTemplate.subject, newContent, emailTemplate.status)
        }, 1000)

    }

    const refreshEmailPreview = (subject, content, status) => {
        if (!stringHelpers.isNullOrEmpty(breachId) && !stringHelpers.isNullOrEmpty(appealId)) {
            setIsLoadingPreview(true)
            setIsPreviewCovered(false)
            if (responseType === "accept") {
                Api.refreshAppealAcceptEmailPreview(
                    data => {
                        setIsLoadingPreview(false)
                        setEmailPreview(data)
                    },
                    error => {
                        setIsLoadingPreview(false);
                        setEmailPreviewError("Failed to load preview.")
                    },
                    breachId, appealId, subject, status, content, organisationId, token
                )
            } else if (responseType === "decline") {
                Api.refreshAppealDeclineEmailPreview(
                    data => {
                        setIsLoadingPreview(false)
                        setEmailPreview(data)
                    },
                    error => {
                        setIsLoadingPreview(false)
                        setEmailPreviewError("Failed to load preview.")
                    },
                    breachId, appealId, subject, status, content, organisationId, token
                )
            }
        }

    }

    const refreshLetterPreview = (updatedTemplateItems, templateId, contactId) => {
        if (!stringHelpers.isNullOrEmpty(breachId)) {
            let letterPreviewAttachmentIds = collateResponseAttachmentIds()
            setIsLoadingPreview(true)
            setIsPreviewCovered(false)
            Api.newLetter(
                organisationId, templateId, breachId, contactId, 0, updatedTemplateItems, letterPreviewAttachmentIds,
                data => {
                    setIsLoadingPreview(false);
                    const blob = new window.Blob([data], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(blob);
                    setPdfView(
                        <iframe
                            src={ fileURL }
                            style={ {
                                border: "0",
                                top: "0",
                                left: "0",
                                bottom: "0",
                                right: "0",
                                width: "100%",
                                height: "100%"
                            } }></iframe>
                    )
                },
                error => {
                    if (error.toString().indexOf('abort') === -1) {
                        setIsLoadingPreview(false);
                    }
                    setPdfView(<p>Failed to load preview.</p>)
                },
                token
            )
        }
    }

    useEffect(() => {
        if (!stringHelpers.isNullOrEmpty(breachId) && !stringHelpers.isNullOrEmpty(appealId)) {
            getBreach()
            getAppeal()
        }

        Api.getAppealResponseOptions(
            appealOptionsData => {
                setAppealOptions(appealOptionsData)
                const hasLetterTemplate = !stringHelpers.isNullOrEmpty(appealOptionsData?.letterTemplateId)
                const hasContactEmail = !stringHelpers.isNullOrEmpty(appealOptionsData?.contactEmailAddress)
                const canSendPost = appealOptionsData.postAvailable && hasLetterTemplate
                const canSendEmail = appealOptionsData.emailAvailable && hasContactEmail
                const mode = canSendEmail ? "1"
                    : canSendPost ? "2"
                    : "0"
                setResponseMode(mode)
                let emailConfig
                Api.getOrganisationSettings(
                    orgSettingsData => {
                        emailConfig = {
                            senderDetails: {
                                name: orgSettingsData.emailSenderName,
                                email: orgSettingsData.emailSenderAddress
                            },
                            subject: responseType === "accept" ? orgSettingsData.appealAcceptedResponseSubject : orgSettingsData.appealDeclinedResponseSubject,
                            status: responseType === "accept" ? orgSettingsData.appealAcceptedResponseStatus : orgSettingsData.appealDeclinedResponseStatus,
                            content: responseType === "accept" ? orgSettingsData.appealAcceptedResponseContent : orgSettingsData.appealDeclinedResponseContent
                        }
                        setEmailTemplate(emailConfig)
                        if (mode === "1") {
                            refreshEmailPreview(emailConfig.subject, emailConfig.content, emailConfig.status)
                        }
                    },
                    error => {
                        console.log(error)
                    },
                    organisationId, token
                )

                if (hasLetterTemplate && !stringHelpers.isNullOrEmpty(appealOptionsData.contactId)) {
                    Api.getSelectedTemplateItems(
                        organisationId,
                        appealOptionsData.letterTemplateId,
                        breachId, appealOptionsData.contactId,
                        templateItemsData => {
                            setTemplateItems(templateItemsData);
                            if (mode === "2") {
                                refreshLetterPreview(templateItemsData, appealOptionsData.letterTemplateId, appealOptionsData.contactId)
                            }
                        },
                        error => console.log(error),
                        token
                    )

                    Api.getLetterTemplate(
                        data => setLetterTemplate(data),
                        error => console.log(error),
                        appealOptionsData.letterTemplateId,
                        organisationId, token
                    )
                }
            },
            error => console.log(error),
            breachId, appealId, responseType,
            organisationId, token
        )


    }, [])

    useEffect(() => {
        if (appeal !== null) {
            const isInitialAttachmentsLoad = attachments === null
            setAttachments(appeal.attachments);
            if (isInitialAttachmentsLoad) {
                const appealAttachments = appeal.attachments ?? []
                const hasImages = appealAttachments.some(attachment => attachment.isImage)
                const hasDocuments = appealAttachments.some(attachment => !attachment.isImage)
                if (!hasImages && hasDocuments) {
                    setAttachmentsDefaultTab("files")
                }
            }
        }
    }, [appeal]);

    useEffect(() => {
        const isLetterPreviewReady = responseMode === "2" && appealOptions !== null && templateItems !== null
        if (isLetterPreviewReady) {
            refreshLetterPreview(templateItems, appealOptions.letterTemplateId, appealOptions.contactId)
        }
    }, [selectedBreachAttachments, selectedSiteAttachments]);

    useEffect(() => {
        if (responseType === "decline") {
            const templateHasAppealSupplementaryResponseVariable = (
                (responseMode === "1" && emailTemplate?.content.includes("{{appealSupplementaryResponse}}"))
                || (responseMode === "2" && letterTemplate?.items.find(item => item.content.includes("{{appealSupplementaryResponse}}")))
            ) 
            if (templateHasAppealSupplementaryResponseVariable) {
                Api.getAppealSupplementaryResponses(
                    data => setAppealSupplementaryResponses(data),
                    error => {
                        console.log(error)
                        setAppealSupplementaryResponses(null)
                    },
                    organisationId, token
                )
            } else {
                setAppealSupplementaryResponses(null)
            }
        }
    }, [emailTemplate, letterTemplate, responseMode])

    const uploadDroppedFile = (file) => {
        const uploadEntry = { file, progress: 1, isComplete: false, isError: false };
        setDropUploads(prev => [...prev, uploadEntry]);

        const payload = new FormData();
        payload.append('file', file);

        const xhr = new XMLHttpRequest();

        xhr.upload.onerror = () => {
            setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, isError: true } : upload));
        };

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    const result = JSON.parse(xhr.response);
                    setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, isComplete: true } : upload));
                    Api.addAppealAttachment(
                        data => {
                            if (data.isError) {
                                setErrorMessage(data.errorMessage)
                            } else {
                                getAppeal()
                            }
                        },
                        (error) => console.log(error),
                        breachId, appealId, result.id, organisationId, token
                    );
                } else {
                    setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, isError: true } : upload));
                }
            }
        };

        xhr.upload.onprogress = (progressEvent) => {
            const percentage = Math.max(1, Math.floor((progressEvent.loaded / progressEvent.total) * 1000) / 10);
            setDropUploads(prev => prev.map(upload => upload.file === file ? { ...upload, progress: percentage } : upload));
        };

        xhr.open('POST', process.env.REACT_APP_APT_API_URL + '/' + organisationId + '/attachments/upload-and-resize-image', true);
        xhr.send(payload);
    };

    const onFileInputChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            Array.from(e.target.files).forEach(file => uploadDroppedFile(file));
            e.target.value = '';
        }
    };

    const onFormDragOver = (e) => { e.preventDefault(); setIsDraggingOver(true); };
    const onFormDragLeave = () => setIsDraggingOver(false);
    const onFormDrop = (e) => {
        e.preventDefault();
        setIsDraggingOver(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            Array.from(e.dataTransfer.files).forEach(file => uploadDroppedFile(file));
        }
    };

    const handleDeleteAttachment = () => {
        Api.deleteAppealAttachment(
            data => {
                if (data.isError) {
                    setErrorMessage(data.errorMessage)
                } else {
                    getAppeal()
                }
                setAttachmentModalId(null)
            },
            (error) => {
                console.log(error)
                setErrorMessage(error.message)
                setAttachmentModalId(null)
            },
            breachId, appealId, attachmentModalId, organisationId, token
        );
    };

    const getResponseAttachments = (breach) => {
        Api.getBreachAttachments(
            (data) => {
                let attachmentsData = [];
                if (breach && !arrayUtilities.isNullOrEmpty(breach.emails)) {
                    attachmentsData = breach.emails.map(email => ({ ...email, isEmail: true }));
                }
                if (!arrayUtilities.isNullOrEmpty(data)) {
                    attachmentsData = [...attachmentsData, ...data];
                }
                setBreachAttachments(sortArrayOfObjectsByTimestampProperty(attachmentsData));
            },
            (error) => console.log(error),
            organisationId, breachId, token
        );

        if (breach && !stringHelpers.isNullOrEmpty(breach.siteId)) {
            Api.getSiteAttachments(
                (data) => setSiteAttachments(data),
                (error) => console.log(error),
                organisationId, breach.siteId, token
            );
        }
    };

    const handleValueUpdate = (value, item, index) => {
        const updatedTemplateItems = templateItems.toSpliced(index, 1, { ...item, content: value })
        setTemplateItems(updatedTemplateItems);
        if (appealOptions) {
            refreshLetterPreview(updatedTemplateItems, appealOptions.letterTemplateId, appealOptions.contactId);
        }
    }

    if (isLoadingPage) return <Loader />
    if (!appeal || !breach || !emailTemplate || !appealOptions) return null

    const canSendPost = appealOptions.postAvailable && !stringHelpers.isNullOrEmpty(appealOptions?.letterTemplateId)
    const hasContactEmail = !stringHelpers.isNullOrEmpty(appealOptions?.contactEmailAddress)
    const canSendEmail = appealOptions?.emailAvailable && hasContactEmail
    const isEmailOnlyMode = canSendEmail && !canSendPost
    const isPostOnlyMode = canSendPost && !canSendEmail
    const hasNoResponseMethod = !canSendPost && !canSendEmail

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-7">
                    {
                        responseMode === "1" && stringHelpers.isNullOrEmpty(emailTemplate.senderDetails.email) && <div className="d-flex align-items-center mb-3 alert alert-danger">
                            <div><i className='fas fa-exclamation-triangle text-danger mr-2'></i></div>
                            <div className="ml-2">
                                <p className="m-0 fs--1">Missing configuration details for email sender. Email responses cannot be sent.&nbsp; 
                                    { 
                                        roleUtilities.isOrganisationAdmin(user, organisationId)
                                        ? <a target="_blank" className="font-weight-bold text-danger" href={ `/organisation/${ organisationId }/organisation-settings#email-settings` }>Review settings <i className="fas fa-external-link-alt"></i></a>
                                        : <a target="_blank" className="font-weight-bold text-danger" href="mailto:support@advancedparking.tech">Contact support <i className="fas fa-external-link-alt"></i></a>
                                    }
                                </p>
                            </div>
                        </div>
                    }
                    {
                        hasNoResponseMethod && <div className="d-flex align-items-center mb-3 alert alert-danger">
                            <div><i className='fas fa-exclamation-triangle text-danger mr-2'></i></div>
                            <div className="ml-2">
                                <p className="m-0 fs--1">No response method is available for this appeal. A response cannot be sent by email or post.&nbsp;
                                    {
                                        roleUtilities.isOrganisationAdmin(user, organisationId)
                                        ? <a target="_blank" className="font-weight-bold text-danger" href={ `/organisation/${ organisationId }/organisation-settings` }>Review settings <i className="fas fa-external-link-alt"></i></a>
                                        : <a target="_blank" className="font-weight-bold text-danger" href="mailto:support@advancedparking.tech">Contact support <i className="fas fa-external-link-alt"></i></a>
                                    }
                                </p>
                            </div>
                        </div>
                    }
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">{ stringHelpers.firstCharacterToUppercase(responseType) } appeal - { breach.referenceNumber }</h5>
                                </div>
                                <Link to={ appealDetailsUrl } className="btn btn-falcon-default btn-sm mr-3 py-1" type="button"><i className="fas fa-reply mr-2"></i>Back</Link>
                            </div>
                        </div>
                        <div className="card-body bg-light border-top details-container">
                            {
                                (canSendPost || canSendEmail) &&
                                <div className="row mb-2">
                                    <div className="col-md-3 col-12 ">
                                        <p className="font-weight-semi-bold mb-3">Method</p>
                                    </div>
                                    <div className="col-md-6 col-12 d-flex flex-column pt-1">
                                        { 
                                        canSendEmail &&
                                            <div className="d-flex align-items-center mb-1">
                                                <input checked={ responseMode === "1" } disabled={ isEmailOnlyMode } id={ "1" } onChange={ () => {
                                                    setResponseMode("1")
                                                    refreshEmailPreview(emailTemplate.subject, emailTemplate.content, emailTemplate.status)
                                                } } className='mr-2' name="response-mode-selection-radio" key={ "1" } value={ "1" }
                                                    type='radio' />
                                                <label className='m-0' htmlFor={ "1" }>Email</label>
                                            </div>
                                        }

                                        { canSendPost &&
                                            <div className="d-flex align-items-center mb-1">
                                                <input checked={ responseMode === "2" } disabled={ isPostOnlyMode } id={ "2" } onChange={ () => {
                                                    setResponseMode("2")
                                                    setIsLoadingPreview(true)

                                                    Api.getLetterTemplate(
                                                        data => setLetterTemplate(data),
                                                        error => console.log(error),
                                                        appealOptions.letterTemplateId,
                                                        organisationId, token
                                                    )

                                                    Api.getSelectedTemplateItems(
                                                        organisationId,
                                                        appealOptions.letterTemplateId,
                                                        breachId, appealOptions.contactId,
                                                        data => {
                                                            setTemplateItems(data);
                                                            if (appealOptions) {
                                                                refreshLetterPreview(data, appealOptions.letterTemplateId, appealOptions.contactId)
                                                            }
                                                        },
                                                        error => console.log(error),
                                                        token
                                                    )
                                                } } className='mr-2' name="response-mode-selection-radio" key={ "2" } value={ "2" }
                                                    type='radio' />
                                                <label className='m-0' htmlFor={ "2" }>Post</label>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }

                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Status</p>
                                </div>
                                <div className="col-md-6 col-12 ">{ Enums.AppealStatus[appeal.appealStatus] }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Reason</p>
                                </div>
                                <div className="col-md-6 col-12 ">{ appeal.appealReason }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Time Stamp</p>
                                </div>
                                <div className="col-md-6 col-12 ">{ toDateTimeString(appeal.timestamp) }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Name</p>
                                </div>
                                <div className="col-md-6 col-12 ">{ appealOptions.contactName }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Company Name</p>
                                </div>
                                <div className="col-md-6 col-12 ">{ appeal.contactDetails.companyName }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Email Address</p>
                                </div>
                                <div className="col-md-6 col-12 ">{ appealOptions.contactEmailAddress }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Contact Number</p>
                                </div>
                                <div className="col-md-6 col-12 ">{ appeal.contactDetails.mobilePhoneNumber }</div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Contact Type</p>
                                </div>
                                <div className="col-md-6 col-12 ">
                                    { Enums.ContactTypes[appeal.contactDetails.contactType] }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Contact Source</p>
                                </div>
                                <div className="col-md-6 col-12 ">
                                    { Enums.ContactSource[appeal.contactDetails.contactSource] }
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-12 col-md-3">
                                    <p className="font-weight-semi-bold mb-3">Address</p>
                                </div>
                                <div className="col-12 col-md-6">
                                    { appeal.contactDetails.addressLine1 && <>{ appeal.contactDetails.addressLine1 }<br /></> }
                                    { appeal.contactDetails.addressLine2 && <>{ appeal.contactDetails.addressLine2 }<br /></> }
                                    { appeal.contactDetails.addressLine3 && <>{ appeal.contactDetails.addressLine3 }<br /></> }
                                    { appeal.contactDetails.townOrCity && <>{ appeal.contactDetails.townOrCity }<br /></> }
                                    { appeal.contactDetails.county && <>{ appeal.contactDetails.county }<br /></> }
                                    { appeal.contactDetails.postCode && <>{ appeal.contactDetails.postCode }<br /></> }
                                    { appeal.contactDetails.country && <>{ appeal.contactDetails.country }<br /></> }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3 col-12 ">
                                    <p className="font-weight-semi-bold mb-3">Date Received</p>
                                </div>
                                <div className="col-md-6 col-12 ">
                                    { toDateString(appeal.timestamp) }
                                </div>
                            </div>
                            { responseMode !== "0" &&
                                <>
                                    <div className="row align-items-start">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-0">Appeal Attachments</p>
                                        </div>
                                        <div className="col-md-7 col-12 ">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <ul className="nav nav-tabs w-100" id="appealAttachmentsTabbed" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button className={ `nav-link ${ attachmentsDefaultTab === "images" ? "active" : "" }` } id="appeal-images-tab" data-toggle="tab" data-target="#appeal-images" type="button" role="tab" aria-controls="appeal-images" aria-selected={ attachmentsDefaultTab === "images" }>
                                                            <i className='far fa-file-image mr-2'></i>
                                                            Images
                                                            <span className={ `ml-2 badge badge-${ attachments?.filter(attachment => attachment.isImage).length === 0 ? "secondary" : "success" }` }>{ attachments?.filter(attachment => attachment.isImage).length }</span>
                                                        </button>
                                                    </li>
                                                    <li className="nav-item" role="presentation">
                                                        <button className={ `nav-link ${ attachmentsDefaultTab === "files" ? "active" : "" }` } id="appeal-files-tab" data-toggle="tab" data-target="#appeal-files" type="button" role="tab" aria-controls="appeal-files" aria-selected={ attachmentsDefaultTab === "files" }>
                                                            <i className='far fa-list-alt mr-2'></i>
                                                            Documents
                                                            <span className={ `ml-2 badge badge-${ attachments?.filter(attachment => !attachment.isImage).length === 0 ? "secondary" : "success" }` }>{ attachments?.filter(attachment => !attachment.isImage).length }</span>
                                                        </button>
                                                    </li>
                                                </ul>
                                                <div className="btn-group">
                                                    <button className="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" data-display="static">
                                                        { attachmentsLayout === 'grid'
                                                            ? <><i className='fas fa-border-all mr-2'></i>Grid</>
                                                            : <><i className='far fa-list-alt mr-2'></i>List</>
                                                        }
                                                    </button>
                                                    <div className="dropdown-menu dropdown-menu-right p-0">
                                                        <button onClick={ () => { setAttachmentsLayout('grid'); localStorage.setItem(attachmentsLayoutKey, 'grid'); } } className="dropdown-item p-2 w-fit">
                                                            <i className='fas fa-border-all mr-2'></i>Grid
                                                        </button>
                                                        <button onClick={ () => { setAttachmentsLayout('list'); localStorage.setItem(attachmentsLayoutKey, 'list'); } } className="dropdown-item p-2 w-fit">
                                                            <i className='far fa-list-alt mr-2'></i>List
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-content" id="appealAttachmentsTabbedContent">
                                                <div className={ `tab-pane fade p-2 bg-white ${ attachmentsDefaultTab === "images" ? "show active" : "" }` } id="appeal-images" role="tabpanel" aria-labelledby="appeal-images-tab">
                                                    <AttachmentsDisplay
                                                        attachments={ !arrayUtilities.isNullOrEmpty(attachments) ? attachments : [] }
                                                        type="images"
                                                        viewLayout={ attachmentsLayout }
                                                        canUpdate={ appeal.appealStatus === 0 }
                                                        onDeleteClick={ id => setAttachmentModalId(id) }
                                                    />
                                                </div>
                                                <div className={ `tab-pane fade p-2 bg-white ${ attachmentsDefaultTab === "files" ? "show active" : "" }` } id="appeal-files" role="tabpanel" aria-labelledby="appeal-files-tab">
                                                    <AttachmentsDisplay
                                                        attachments={ !arrayUtilities.isNullOrEmpty(attachments) ? attachments : [] }
                                                        type="documents"
                                                        viewLayout={ attachmentsLayout }
                                                        canUpdate={ appeal.appealStatus === 0 }
                                                        onDeleteClick={ id => setAttachmentModalId(id) }
                                                    />
                                                </div>
                                            </div>
                                            { !stringHelpers.isNullOrEmpty(errorMessage) && <ErrorModal onHide={ () => setErrorMessage(null) } message={ errorMessage } /> }
                                            {
                                                !stringHelpers.isNullOrEmpty(attachmentModalId)
                                                && <Modal show onHide={ () => setAttachmentModalId(null) }>
                                                    <Modal.Header>
                                                        <Modal.Title className='text-danger'>Delete Attachment</Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>Are you sure you want to delete this attachment?</Modal.Body>
                                                    <Modal.Footer>
                                                        <button className="btn btn-falcon-default btn-sm" onClick={ () => setAttachmentModalId(null) }>Cancel</button>
                                                        <button className="btn btn-sm btn-danger mt-1" onClick={ handleDeleteAttachment }>Delete</button>
                                                    </Modal.Footer>
                                                </Modal>
                                            }
                                            { appeal.appealStatus === 0 && dropUploads.filter(upload => !upload.isComplete).length > 0 && (
                                                <div className="mt-2">
                                                    { dropUploads.filter(upload => !upload.isComplete).map((upload, index) => (
                                                        <div key={ 'drop-' + index } className="mb-1">
                                                            <span className="text-truncate d-block mb-1 small">{ upload.file.name }</span>
                                                            { upload.isError
                                                                ? <small className="text-danger"><i className="fas fa-times"></i> Upload failed</small>
                                                                : <div className="progress" style={ { height: '4px' } }>
                                                                    <div className="progress-bar" style={ { width: upload.progress + '%' } } />
                                                                </div>
                                                            }
                                                        </div>
                                                    )) }
                                                </div>
                                            ) }
                                            { appeal.appealStatus === 0 && <div
                                                className={ `mt-3 p-3 text-center border rounded${ isDraggingOver ? ' border-primary' : ' border-dashed' }` }
                                                onDragOver={ onFormDragOver }
                                                onDragLeave={ onFormDragLeave }
                                                onDrop={ onFormDrop }
                                                style={ { backgroundColor: isDraggingOver ? '#e8f0fe' : 'transparent' } }
                                            >
                                                <input type="file" ref={ fileInputRef } onChange={ onFileInputChange } multiple style={ { display: 'none' } } accept="image/*,application/pdf,.doc,.docx" />
                                                <button className="btn btn-falcon-default btn-sm" onClick={ () => fileInputRef.current.click() }>
                                                    <i className="fas fa-plus"></i> Add Attachments
                                                </button>
                                                <p className="mb-0 mt-1 small" style={ { color: isDraggingOver ? '#2c7be5' : '#9da9bb' } }>
                                                    { isDraggingOver ? 'Drop to upload' : 'or drag and drop files here' }
                                                </p>
                                            </div> }
                                        </div>
                                    </div>
                                </> }
                            {
                                responseMode === "1" &&
                                <>
                                    <hr className="border-dashed border-bottom-0"></hr>
                                    <div className="row mb-2">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-0 mt-1">Subject</p>
                                        </div>
                                        <div className="col-md-7 col-12 ">
                                            <div className="form-group mb-0">
                                                <input className="form-control mb-1 form-control-sm" type="text" value={ emailTemplate.subject } onChange={ (e) => changeSubject(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-md-3 col-12 ">
                                            <p className="font-weight-semi-bold mb-0 mt-1">Content</p>
                                        </div>
                                        <div className="col-md-7 col-12 ">
                                            <div className="form-group mb-0">
                                                <textarea rows={ 8 } className="form-control mb-1 form-control-sm" type="text" value={ emailTemplate.content } onChange={ (e) => changeContent(e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                responseMode === "2" &&
                                <>
                                <hr className="border-dashed border-bottom-0"></hr>
                                    {
                                        !arrayUtilities.isNullOrEmpty(templateItems) &&
                                        templateItems.map((item, index) =>
                                            <div key={ index } className="row mb-3">
                                                <NewLetterEditTemplateItem
                                                    isSendingLetter={ isSendingResponse }
                                                    item={ item }
                                                    handleValueUpdate={ value => handleValueUpdate(value, item, index) }
                                                    onValueChanging={ () => setIsPreviewCovered(true) } />

                                            </div>
                                        )
                                    }
                                </>
                            }
                            {!arrayUtilities.isNullOrEmpty(appealSupplementaryResponses) &&
                            <div className="row mb-3">
                                <div className="col-md-3 col-12">Supplementary Response</div>
                                <div className="col-md-7 col-12">
                                    <select selected={selectedAppealSupplementaryResponse} onChange={e => {
                                        if (stringHelpers.isNullOrEmpty(e.target.value)) {
                                            setSelectedAppealSupplementaryResponse(null)
                                        } else {
                                            setSelectedAppealSupplementaryResponse(e.target.value)
                                        }
                                    }} className="form-control">
                                        <option value="">None</option>
                                        {
                                            appealSupplementaryResponses.map(
                                                response => <option value={response.id} key={response.id}>{ response.name }</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </div>}
                            {
                                responseMode !== "0" &&
                                <>
                                    <AttachmentSelectTable
                                        label="Breach Attachments"
                                        imagesOnly
                                        idPrefix="appeal-breach-attachment"
                                        attachments={ breachAttachments }
                                        selected={ selectedBreachAttachments }
                                        setSelected={ setSelectedBreachAttachments }
                                        isSelectAllChecked={ isSelectAllBreachAttachmentsChecked }
                                        setIsSelectAllChecked={ setIsSelectAllBreachAttachmentsChecked } />
                                    <AttachmentSelectTable
                                        label="Site Attachments"
                                        isSite={ true }
                                        imagesOnly
                                        idPrefix="appeal-site-attachment"
                                        attachments={ siteAttachments }
                                        selected={ selectedSiteAttachments }
                                        setSelected={ setSelectedSiteAttachments }
                                        isSelectAllChecked={ isSelectAllSiteAttachmentsChecked }
                                        setIsSelectAllChecked={ setIsSelectAllSiteAttachmentsChecked } />
                                </>
                            }
                            
                        </div>  
                        <div className="card-footer border-top d-flex justify-content-end">
                            <Link to={ appealDetailsUrl } className="btn btn-falcon-default btn-sm">Cancel</Link>
                            <button onClick={ () => {
                                const isMissingEmailPreview = responseMode === "1" && !emailPreview
                                if (!appealOptions || isMissingEmailPreview) return

                                setIsSendingResponse(true)
                                if (responseType === "accept") {
                                    Api.acceptAppeal(
                                        data => { 
                                            setIsSendingResponse(false)
                                            if (data.isError) {
                                                setErrorMessage(data.errorMessage)
                                            } else {
                                                history.push(`${breachDetailsUrl}`)
                                            }
                                        },
                                        (error) => {
                                            setIsSendingResponse(false)
                                            setErrorMessage(error);
                                        },
                                        breachId, appealId, null, collateResponseAttachmentIds(),
                                        Number(responseMode),
                                        appealOptions.letterTemplateId,
                                        !arrayUtilities.isNullOrEmpty(templateItems) ? templateItems : null, emailPreview?.subject, emailPreview?.content, emailPreview?.status,
                                        organisationId,
                                        token
                                    )
                                } else {
                                    Api.declineAppeal(
                                        data => { 
                                            setIsSendingResponse(false)
                                            if (data.isError) {
                                                setErrorMessage(data.errorMessage)
                                            } else {
                                                history.push(`${breachDetailsUrl}`)
                                            }
                                        },
                                        (error) => {
                                            setIsSendingResponse(false)
                                            setErrorMessage(error)
                                        },
                                        breachId, appealId, null, collateResponseAttachmentIds(),
                                        Number(responseMode), appealOptions.letterTemplateId,
                                        templateItems, emailPreview?.subject, emailPreview?.content, emailPreview?.status, selectedAppealSupplementaryResponse,
                                        organisationId,
                                        token
                                    )
                                }
                            } } disabled={ responseMode < 1 || (responseMode === "1" && stringHelpers.isNullOrEmpty(emailTemplate.senderDetails.email)) } className="btn btn-success btn-sm ml-2">Submit</button>
                        </div>
                    </div>
                </div>

                <div className='col-5'>
                    {
                        isLoadingPreview || isSendingResponse
                            ? <div className="d-flex align-items-start preview-pdf-container">
                                <Loader />
                            </div>
                            : responseMode === "1" ?
                                <div className="p-4 bg-white rounded-lg position-relative">
                                    { isPreviewCovered && <div className="preview-pending-cover"><Loader /></div> }
                                    {
                                        !stringHelpers.isNullOrEmpty(emailPreviewError)
                                        ? <p>{emailPreviewError}</p>
                                        : emailTemplate && emailPreview && 
                                            <>
                                                <div className="row mb-2 d-flex align-items-center">
                                        <div className="col-2">
                                            <p className="m-0 mr-2"><b>From:</b></p>
                                        </div>
                                        <div className="col-10">
                                            <p className="m-0">{ emailTemplate.senderDetails.name }&nbsp;
                                                {
                                                    !stringHelpers.isNullOrEmpty(emailTemplate.senderDetails.email)
                                                    && <span className="text-muted">&lt;{ emailTemplate.senderDetails.email }&gt;</span>
                                                }
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row d-flex mb-2">
                                        <div className="col-2">
                                            <p className="m-0 mr-2"><b>Sent:</b></p>
                                        </div>
                                        <div className="col-10">
                                            <p className="m-0">
                                                { toLongDateTimeString(new Date()) }
                                            </p>
                                        </div>
                                    </div>

                                    <div className="row d-flex mb-2">
                                        <div className="col-2">
                                            <p className="m-0 mr-2"><b>To:</b></p>
                                        </div>
                                        <div className="col-10">
                                            <p className="m-0">{ appealOptions.contactName }&nbsp;<span className="text-muted">&lt;{ appealOptions.contactEmailAddress }&gt;</span></p>
                                        </div>
                                    </div>

                                    <div className="row d-flex mb-2">
                                        <div className="col-2">
                                            <p className="m-0 mr-2"><b>Subject:</b></p>
                                        </div>
                                        <div className="col-10">
                                            <p className="m-0">{ emailPreview.subject }</p>
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        {
                                            emailPreview.content
                                                .split("\n")
                                                .map(line => <p className="m-0">{ line }<br /></p>)
                                        }
                                    </div>
                                            </>

                                    }
                                </div>
                                : responseMode === "2" && <div id="preview-pdf" className="preview-pdf-container">
                                { pdfView }
                                { isPreviewCovered && <div className="preview-pending-cover"><Loader /></div> }
                            </div>
                    }

                </div>
            </div>
        </div>
    )
}